<template>
  <div class="header">
    <div class="d1"></div>
    <div class="d2">{{ title }}</div>
    <div class="d3">
      <el-dropdown @command="handleCommand" v-show="nameStatus">
        <div class="el-dropdown-link" style="display: flex;align-items: center;color: #fff;cursor: pointer;">
          <el-avatar icon="el-icon-user-solid" v-if="!head"></el-avatar>
          <el-avatar :src="head" v-else></el-avatar>
          <span class="name">{{ nickName }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="url">首页</el-dropdown-item>
          <el-dropdown-item v-if="userType == 20" command="/adminmanage">后台管理</el-dropdown-item>
          <el-dropdown-item command="/center">个人中心</el-dropdown-item>
          <el-dropdown-item divided command="exit">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils/auth'
import store from '../../../store'
export default {
  props: {
    title: String,
    nameStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      nickName: getCookie('nickname'),
      head: getCookie('head'),
      userType: getCookie('userType'),
      url: '/' + getCookie('redirectUrl')
    }
  },
  mounted () {
  },
  methods: {
    handleCommand (url) {
      if (url === 'exit') {
        store.dispatch('FedLogOut').then(() => {
          location.reload()
        })
      } else {
        this.$router.push(url)
      }
    },
    changeHead (url) {
      this.head = url
    }
  }
}
</script>
<style lang="scss" scoped>
.header{
  display: flex;
  align-items: flex-end;
  text-align: center;
  line-height: 86px;
  width: 100%;
  height: 86px;
  background: url('../../../assets/img/header-bg.png') top left/100% 86px no-repeat;
  .d1{
    width: 30%;
    font-size: 24px;
    letter-spacing: 2px;
    text-indent: 20px;
    color: #26baff;
    height: 50px;
    line-height: 50px;
    text-align: left;
    @media screen and (max-width: 1300px){
      font-size: 18px;
    }
    @media screen and (min-width: 1300px) and (max-width: 1600px){
      font-size: 22px;
    }
  }
  .d2{
    width: 40%;
    font-size: 30px;
    letter-spacing: 8px;
    color: #FFFFFF;
    text-shadow: 2px 2px 8px #b8f5f5;
  }
  .d3{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 30%;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    color: #52FFFF;
    padding-right: 10px;
    span{
      margin-right: 10px;
      &.name{
        margin-right: 0;
        max-width: 118px;
        min-width: 28px;
        overflow:hidden; //超出的文本隐藏
        text-overflow:ellipsis; //用省略号显示
        white-space:nowrap; //不换行
      }
    }
    img{
      margin: 0 11px;
    }
  }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/views/base/safeHeader/safeHeader.vue